import i18n, {InitOptions} from 'i18next';

// `en` is the fallbackLng and the only language the static export is
// pre-rendered in (see pages/_app.tsx's hardcoded lang={LangCode.en}), so it's
// the only one that needs to be ready synchronously at init. Every other
// language is loaded on demand by ensureLanguageLoaded() (see lazyLanguages.ts)
// right before changeLanguage() is called, instead of shipping all 13
// languages' translation+badges+tutorials JSON (~1MB) to every visitor.
import en from './json/en.json';
import en_badges from './json/badges/en.json'
import en_tutorials from './json/tutorials/en.json'

import {I18NFactory} from 'i18next-react';
import {LangCode} from './languages';

const defaultI18nOptions: InitOptions = {
  fallbackLng: LangCode.en,
  defaultNS: 'translation',
  ns: ['translation'],
  resources: {
    [LangCode.en]: { translation: combineJSONFiles(en, en_badges, en_tutorials) },
  },
};



function combineJSONFiles (language, badges, tutorials) {
  return Object.assign(language, Object.assign(badges, tutorials))
}

/**
 * A simplest I18NFactory
 * @param {boolean} forSSR
 * @param {string} lng
 * @returns {i18n}
 */
export const createI18nInstance: I18NFactory = (forSSR: boolean, lng?: string) => {
  const instance = i18n.createInstance({
    ...defaultI18nOptions,
    initImmediate: !forSSR,
    lng,
  });
  instance.init();
  return instance;
};
